import { useState } from 'react';
import { Button } from '@/shared/components/ui/Button';
import { useNotificationSettings } from '../hooks/useAdmin';
import { NotificationsTable } from './NotificationsTable';
import { NotificationForm } from './NotificationForm';
import type { NotificationSettingsWithLocation } from '../services/notificationSettingsService';

export function NotificationsTab() {
  const { data: notifications, isLoading } = useNotificationSettings();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingNotification, setEditingNotification] = useState<
    NotificationSettingsWithLocation | undefined
  >();

  const handleAdd = () => {
    setEditingNotification(undefined);
    setIsFormOpen(true);
  };

  const handleEdit = (notification: NotificationSettingsWithLocation) => {
    setEditingNotification(notification);
    setIsFormOpen(true);
  };

  const handleClose = () => {
    setIsFormOpen(false);
    setEditingNotification(undefined);
  };

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">
            Notification Settings
          </h2>
          <p className="mt-1 text-sm text-gray-600">
            Configure automated email notifications for various events
          </p>
        </div>
        <Button onClick={handleAdd}>Add Notification</Button>
      </div>

      <NotificationsTable
        notifications={notifications || []}
        onEdit={handleEdit}
        isLoading={isLoading}
      />

      <NotificationForm
        isOpen={isFormOpen}
        onClose={handleClose}
        notification={editingNotification}
      />
    </div>
  );
}
